var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activity"},[_c('object',{attrs:{"id":"game","title":"game","data":this.$route.params.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }